/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/apple_watch_medium'
export default icon
